import { useState } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { PageShell, Section } from '~/components/layout';
import { AudienceToggle, CtaBanner, PricingTable } from '~/components/sections';
import type { Audience } from '~/content/pricing';
import { pageHeadMeta } from '~/lib/seo';
import pricingStylesHref from '~/styles/pricing.css?url';

export const Route = createFileRoute('/pricing')({
  head: () =>
    pageHeadMeta({
      title: 'Pricing – nsave',
      description:
        "Compare nsave's Free and Pro plans. Send money internationally, get USD/GBP accounts, and invest with transparent pricing. Pro plan just $9.99/month.",
      path: '/pricing',
      stylesheets: [pricingStylesHref],
    }),
  component: PricingPage,
});

function PricingPage() {
  const [audience, setAudience] = useState<Audience>('personal');

  return (
    <PageShell>
      <Section className="pt-16 md:pt-24 !pb-10">
        <div className="mx-auto flex max-w-3xl flex-col items-center gap-12 text-center">
          <h1 className="text-[40px] leading-[1.1] font-semibold tracking-[-0.03em] text-balance md:text-title-m">
            Keep Your Earnings
          </h1>
          <AudienceToggle value={audience} onChange={setAudience} />
        </div>
      </Section>
      <PricingTable audience={audience} />
      <CtaBanner />
    </PageShell>
  );
}
